import type React from 'react';
import classes from './login-page.module.scss';
import { Navigate } from 'react-router-dom';
import { useLoginPageController } from './useLoginPageController';
import { ShiftPwaControls } from '../../components/ShiftPwaControls';

export const LoginPage: React.FC = () => {
  const { isAuthenticated, tenantId, setTenantId, username, setUsername, password, setPassword, error, isLoading, onSubmit } =
    useLoginPageController();

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="page">
      <section className={`card ${classes.loginCard}`}>
        <div className={classes.logoWrap}>
          <img src="/OfficialLogoShift.png" alt="Comm.it SHIFT" className={classes.logo} />
        </div>
        <form className="form" onSubmit={onSubmit} dir="rtl" noValidate>
          <label className="label" htmlFor="tenant-id">שם עסק</label>
          <input id="tenant-id" className="input" value={tenantId} maxLength={50} required
            placeholder="שם עסק"
            autoComplete="organization" autoCapitalize="none" spellCheck={false}
            onChange={(event) => setTenantId(event.currentTarget.value)}
            onContextMenu={(event) => event.preventDefault()} onSelect={(event) => event.preventDefault()}
            style={{ userSelect: 'none', WebkitTouchCallout: 'none' }} />
          <label className="label" htmlFor="username">
            שם משתמש
          </label>
          <input
            id="username"
            className="input"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoComplete="username"
            placeholder="שם משתמש"
          />
          <label className="label" htmlFor="password">
            סיסמה
          </label>
          <input
            id="password"
            className="input"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            placeholder="סיסמה"
          />
          {error && <p className="errorText">{error}</p>}
          <button className="button" type="submit" disabled={isLoading}>
            {isLoading ? 'מתחבר...' : 'התחבר'}
          </button>
        </form>
        <ShiftPwaControls />
        <p className={classes.loginFooter}>
          Powered by <span>CommunicateAI</span>
        </p>
      </section>
    </main>
  );
};
